<template>
  <div class="timestamp-cell">
    <div class="d-block date" v-if="formattedDate">
      <feather-icon icon="CalendarIcon" class="" />
      {{ formattedDate }}
    </div>
    <div class="d-block time" v-if="formattedTime">
      <feather-icon icon="ClockIcon" class="" />
      {{ formattedTime }}
    </div>
    <div class="user" v-if="byUser">
      <b-badge variant="light-secondary" class="d-block text-muted user" v-if="byUser">
        <feather-icon icon="UserIcon" class="" />
        {{ byUser }}
      </b-badge>
    </div>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue';
import moment from 'moment';

export default {
  name: 'TimestampCell',
  components: {
    BBadge,
  },
  props: {
    timestamp: {
      type: String | null,
      required: true,
      default: '-',
    },
    byUser: {
      type: String,
      default: '-',
    },
    dateFormat: {
      type: String,
      default: 'DD MMM, YYYY',
    },
    timeFormat: {
      type: String,
      default: 'hh:mm a',
    },
  },
  computed: {
    formattedDate() {
      if (!this.timestamp) return '-';
      return moment(this.timestamp).format(this.dateFormat);
    },
    formattedTime() {
      if (!this.timestamp) return '-';
      return moment(this.timestamp).format(this.timeFormat);
    },
  },
};
</script>

<style lang="scss" scoped>
.timestamp-cell {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .date {
    font-size: 0.9rem;
  }
  .time {
    font-size: 0.75rem;
  }
  .user {
    display: flex !important;
    justify-content: start;
    align-items: center;

    .badge {
      font-size: 0.8rem;
      opacity: 0.8;
      gap: 4px;
    }
  }
}
</style>
